import { css } from 'styled-components';

import { tokens } from './tokens';

export const podNameVars = css`
    --yat_editable-text-area-font-family: 'Alliance No.1';
    --yat_editable-text-area-font-size: ${tokens.podName.fontSize.mobile}px;
    --yat_editable-text-area-font-weight: 700;
    --yat_editable-text-area-letter-spacing: -0.03em;
    --yat_editable-text-area-line-height: ${tokens.podName.lineHeight.mobile};
    --yat_editable-text-area-color: ${({ theme }) => theme.colors.white};
    --yat_editable-text-area-placeholder-color: ${({ theme }) => theme.shades.white['50']};
    --yat_editable-text-area-shadow: 0 0 15px ${({ theme }) => theme.shades.white['50']},
        0 0 20px ${({ theme }) => theme.colors.purple};
    --yat_editable-text-area-padding: ${tokens.editableName.padding}px;
    --yat_editable-text-area-radius: ${tokens.editableName.radius}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        --yat_editable-text-area-font-size: ${tokens.podName.fontSize.tablet}px;
        --yat_editable-text-area-line-height: ${tokens.podName.lineHeight.tablet};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
        --yat_editable-text-area-font-size: ${tokens.podName.fontSize.desktop}px;
        --yat_editable-text-area-line-height: ${tokens.podName.lineHeight.desktop};
    }
`;

export const podNameTypography = css`
    font-family: var(--yat_editable-text-area-font-family);
    font-size: var(--yat_editable-text-area-font-size);
    font-weight: var(--yat_editable-text-area-font-weight);
    line-height: var(--yat_editable-text-area-line-height);
    letter-spacing: var(--yat_editable-text-area-letter-spacing);
    text-align: left;
    color: ${({ theme }) => theme.colors.white};
`;
